// extracted by mini-css-extract-plugin
module.exports = {"button":"carousel_button__3hcv5"};